export default (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/arrayToObject.js
// module id = 1348
// module chunks = 7